<template>
    <header class="ras-header">
        <div class="ras-header__restart">
            <a
                href="/"
                @click.prevent="restart"
                v-if="this.$route.path !== '/person'"
                >Start Again</a
            >
        </div>
        <div class="ras-header__logo">
            <a
                style="display: flex"
                href="https://www.mybaggage.com/"
                target="_blank"
            >
                <SVGJetflixLine />
            </a>
        </div>
        <div>
            <SVGInfo v-if="!getAboutStatus" @click="toggleAbout" />
            <SVGClose v-else @click="toggleAbout" />
        </div>
    </header>
</template>

<script>
import SVGJetflixLine from '@/assets/svgs/jetflix-line.svg?inline'
import SVGInfo from '@/assets/svgs/info.svg?inline'
import SVGClose from '@/assets/svgs/close.svg?inline'
import { mapGetters } from 'vuex'

export default {
    components: {
        SVGJetflixLine,
        SVGInfo,
        SVGClose
    },
    computed: {
        ...mapGetters(['getAboutStatus'])
    },
    methods: {
        toggleAbout() {
            this.$store.dispatch('setAboutStatus', !this.getAboutStatus)
        },
        restart() {
            this.$store.dispatch('restart').then(() => {
                this.$router.push({ path: '/' })
            })
        }
    }
}
</script>

<style lang="scss">
.ras-main {
    .ras-header {
        position: fixed;
        width: 100%;
        height: $m-header-height;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: $c-black;
        padding: 0 20px;
        z-index: 10;

        @media (min-width: map_get($breakpoints, lg)) {
            height: $d-header-height;
            padding: 0 36px;
        }

        @media (min-width: map_get($breakpoints, lg)) and (max-height: map_get($v-breakpoints, sm)) {
            height: $d-small-header-height;
        }

        &__restart {
            display: none;
            width: 85px;

            @media (min-width: map_get($breakpoints, lg)) {
                display: block;
            }

            a {
                color: $white;
                font-size: 22px;
                text-transform: uppercase;
                text-decoration: none;
                font-family: $ff-heading;
            }
        }

        &__logo {
            max-width: 225px;

            @media (min-width: map_get($breakpoints, lg)) {
                max-width: 360px;
            }

            svg {
                width: 100%;
            }
        }
    }
}
</style>
